
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chapterId]/tafsirs/[tafsirId]",
      function () {
        return require("private-next-pages/[chapterId]/tafsirs/[tafsirId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[chapterId]/tafsirs/[tafsirId]"])
      });
    }
  